import { Link } from 'react-router-dom';
import type { WritePolicy } from '../api';
import { writeBlockedNotice } from '../writeBlockedNotice.js';

/**
 * The rendering half of `writeBlockedNotice`. The wording and the rule live in
 * that module so they can be tested without a DOM; this only puts them on the
 * page. See the warning there before changing what it keys off.
 */
export function WriteBlockedNotice({
  policy,
  tenantId,
  place,
  onNavigate,
}: {
  policy: WritePolicy | null;
  tenantId: string;
  place: 'instance' | 'edits';
  /**
   * How to leave, when the caller has something to lose.
   *
   * ⚠ The grid passes its leave-confirmation here. Without it this was a plain
   * <Link>, so the one notice telling a customer their edits were safe was
   * also the control that silently discarded them. A screen with no pending
   * state omits this and gets ordinary navigation.
   */
  onNavigate?: (destination: string, to: string) => void;
}) {
  const notice = writeBlockedNotice(policy, tenantId, place);
  if (!notice) return null;

  return (
    <div className="notice error">
      <strong>{notice.heading}</strong> {notice.body}
      {notice.action && (
        <>
          {' '}
          {onNavigate ? (
            <button
              type="button"
              className="link-button"
              onClick={() => onNavigate('the billing page', notice.action!.to)}
            >
              {notice.action.label}
            </button>
          ) : (
            <Link to={notice.action.to}>{notice.action.label}</Link>
          )}
        </>
      )}
    </div>
  );
}
